const taskIcon = ({ amount = 0, show_reward: showReward = false }) => {
  if (amount > 0 || showReward) return 'money-income';

  return 'system-update';
};

export default taskIcon;
